// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.printer-agent-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 60px;
}

.printer-agent-title {
  font-weight: 600;
  color: #1976d2;
  margin-bottom: 8px;
}

.status-section,
.printers-section,
.download-section,
.instructions-section,
.troubleshooting-section {
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 8px;
}

.status-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.printers-section {
  background: #ffffff;
}

.download-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.download-section .MuiTypography-root {
  color: white;
}

.download-button {
  margin-top: 12px;
  padding: 12px;
  font-weight: 600;
  text-transform: none;
  font-size: 16px;
  background-color: white !important;
  color: #764ba2 !important;
}

.download-button:hover {
  background-color: rgba(255, 255, 255, 0.9) !important;
}

.instructions-section {
  background: #f8f9fa;
}

.instruction-steps {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.instruction-step {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.step-number {
  background: #1976d2;
  color: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.troubleshooting-section {
  background: #fff3e0;
  border-left: 4px solid #ff9800;
}

.troubleshooting-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.troubleshooting-item {
  padding: 4px 0;
  color: #424242;
}

/* Table styles */
.MuiTableHead-root {
  background-color: #f5f5f5;
}

.MuiTableHead-root .MuiTableCell-root {
  font-weight: 600;
  color: #424242;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.MuiTableBody-root .MuiTableCell-root {
  padding: 12px 16px;
}

/* Responsive design */
@media (max-width: 768px) {
  .printer-agent-container {
    padding: 16px;
  }
  
  .status-section,
  .printers-section,
  .download-section,
  .instructions-section,
  .troubleshooting-section {
    padding: 16px;
  }
  
  .instruction-step {
    flex-direction: column;
    gap: 8px;
  }
  
  .MuiTable-root {
    font-size: 12px;
  }
  
  .MuiTableCell-root {
    padding: 8px;
  }
}

/* ── Dark mode ── */
.dark .status-section {
  background: #1e293b;
  color: #f1f5f9;
}

.dark .printers-section {
  background: #1e293b;
  color: #f1f5f9;
}

.dark .instructions-section {
  background: #1e293b;
  color: #f1f5f9;
}

.dark .troubleshooting-section {
  background: #1e293b;
  border-left-color: #ff9800;
  color: #f1f5f9;
}

.dark .troubleshooting-item {
  color: #cbd5e1;
}

.dark .download-button {
  background-color: #334155 !important;
  color: #f1f5f9 !important;
}

.dark .MuiTableHead-root {
  background-color: #334155;
}

.dark .MuiTableHead-root .MuiTableCell-root {
  color: #f1f5f9;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/PrinterAgent/PrinterAgent.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;;;;IAKE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".printer-agent-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 60px;\n}\n\n.printer-agent-title {\n  font-weight: 600;\n  color: #1976d2;\n  margin-bottom: 8px;\n}\n\n.status-section,\n.printers-section,\n.download-section,\n.instructions-section,\n.troubleshooting-section {\n  padding: 20px;\n  margin-bottom: 20px;\n  border-radius: 8px;\n}\n\n.status-section {\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n}\n\n.printers-section {\n  background: #ffffff;\n}\n\n.download-section {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.download-section .MuiTypography-root {\n  color: white;\n}\n\n.download-button {\n  margin-top: 12px;\n  padding: 12px;\n  font-weight: 600;\n  text-transform: none;\n  font-size: 16px;\n  background-color: white !important;\n  color: #764ba2 !important;\n}\n\n.download-button:hover {\n  background-color: rgba(255, 255, 255, 0.9) !important;\n}\n\n.instructions-section {\n  background: #f8f9fa;\n}\n\n.instruction-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.instruction-step {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.step-number {\n  background: #1976d2;\n  color: white;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.troubleshooting-section {\n  background: #fff3e0;\n  border-left: 4px solid #ff9800;\n}\n\n.troubleshooting-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.troubleshooting-item {\n  padding: 4px 0;\n  color: #424242;\n}\n\n/* Table styles */\n.MuiTableHead-root {\n  background-color: #f5f5f5;\n}\n\n.MuiTableHead-root .MuiTableCell-root {\n  font-weight: 600;\n  color: #424242;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.MuiTableBody-root .MuiTableCell-root {\n  padding: 12px 16px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .printer-agent-container {\n    padding: 16px;\n  }\n  \n  .status-section,\n  .printers-section,\n  .download-section,\n  .instructions-section,\n  .troubleshooting-section {\n    padding: 16px;\n  }\n  \n  .instruction-step {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .MuiTable-root {\n    font-size: 12px;\n  }\n  \n  .MuiTableCell-root {\n    padding: 8px;\n  }\n}\n\n/* ── Dark mode ── */\n.dark .status-section {\n  background: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .printers-section {\n  background: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .instructions-section {\n  background: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .troubleshooting-section {\n  background: #1e293b;\n  border-left-color: #ff9800;\n  color: #f1f5f9;\n}\n\n.dark .troubleshooting-item {\n  color: #cbd5e1;\n}\n\n.dark .download-button {\n  background-color: #334155 !important;\n  color: #f1f5f9 !important;\n}\n\n.dark .MuiTableHead-root {\n  background-color: #334155;\n}\n\n.dark .MuiTableHead-root .MuiTableCell-root {\n  color: #f1f5f9;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
